import { useMediaQuery } from "@crehana/react-hooks";
import { Col, Row } from "@crehana/ui";
import { LearnMentorCardSkeleton } from "../../../../components/Cards/LearnMentorCard/Default";
import { MentorCardSkeleton } from "../../../../components/Cards/MentorCard/Default";
import { jsx as _jsx } from "react/jsx-runtime";
var MentorsListSkeleton = function MentorsListSkeleton(_ref) {
  var _LearnMentorCardSkele, _MentorCardSkeleton;
  var isDark = _ref.isDark,
    isFromLearnDashboard = _ref.isFromLearnDashboard;
  var _useMediaQuery = useMediaQuery('md'),
    isMd = _useMediaQuery.matches;
  var _useMediaQuery2 = useMediaQuery('lg'),
    isLg = _useMediaQuery2.matches;
  var getMentorsByPage = function getMentorsByPage() {
    if (isLg) {
      return 8;
    }
    if (isMd) {
      return 6;
    }
    return 4;
  };
  return /*#__PURE__*/_jsx(Row, {
    className: "mt-12",
    gutter: {
      md: 24,
      sm: 16
    },
    itemsPerRow: {
      lg: 4,
      md: 3,
      sm: 2,
      xs: 1
    },
    children: Array.from({
      length: getMentorsByPage()
    }).map(function (_, index) {
      return /*#__PURE__*/_jsx(Col, {
        children: isFromLearnDashboard ? _LearnMentorCardSkele || (_LearnMentorCardSkele = /*#__PURE__*/_jsx(LearnMentorCardSkeleton, {
          isDark: isDark
        })) : _MentorCardSkeleton || (_MentorCardSkeleton = /*#__PURE__*/_jsx(MentorCardSkeleton, {
          isDark: isDark
        }))
      }, "mentor-card-skeleton-".concat(index * 1));
    })
  });
};
export default MentorsListSkeleton;